class AssetFormat {
    constructor() {
        this.canDownload = false;
        this.creationDate = null;
        this.externalId = null;
        this.externalState = null;
        this.feature = null;
        this.id = null;
        this.state = null;
        this.isPreparingDownload = false;
    }
}

export { AssetFormat };
